import { NotificationType } from '../enums/notification/notification-type.enum';
import { NotificationConfiguration } from '../models/notification/notification-configuration';

export const NotificationConfigurationConstant: Record<
  NotificationType,
  NotificationConfiguration
> = {
  [NotificationType.CNP_START_FOLLOW_YOU]: {
    icon: 'fa-user-plus',
    title: 'NOTIFICATIONS.TYPES.CNP_START_FOLLOW_YOU.TITLE',
    description: 'NOTIFICATIONS.TYPES.CNP_START_FOLLOW_YOU.DESCRIPTION',
    color: '#4e92ce',
  },
  [NotificationType.CNP_REACT_TO_THREAD]: {
    icon: 'fa-thumbs-up',
    title: 'NOTIFICATIONS.TYPES.CNP_REACT_TO_THREAD.TITLE',
    description: 'NOTIFICATIONS.TYPES.CNP_REACT_TO_THREAD.DESCRIPTION',
    color: '#4e92ce',
  },
  [NotificationType.CNP_REACT_TO_COMMENT]: {
    icon: 'fa-thumbs-up',
    title: 'NOTIFICATIONS.TYPES.CNP_REACT_TO_COMMENT.TITLE',
    description: 'NOTIFICATIONS.TYPES.CNP_REACT_TO_COMMENT.DESCRIPTION',
    color: '#4e92ce',
  },
  [NotificationType.CNP_COMMENT_IN_THREAD]: {
    icon: 'fa-comment-dots',
    title: 'NOTIFICATIONS.TYPES.CNP_COMMENT_IN_THREAD.TITLE',
    description: 'NOTIFICATIONS.TYPES.CNP_COMMENT_IN_THREAD.DESCRIPTION',
    color: '#4ecec3',
  },
  [NotificationType.CNP_VOTE_IN_CASE]: {
    icon: 'fa-check-circle',
    title: 'NOTIFICATIONS.TYPES.CNP_VOTE_IN_CASE.TITLE',
    description: 'NOTIFICATIONS.TYPES.CNP_VOTE_IN_CASE.DESCRIPTION',
    color: '#b549d0',
  },
};
